export default __webpack_public_path__ + "static/media/mo-img-team-advisros-hg3x.c8d78c5a.png";